import { Injectable } from '@angular/core';
import { Zona } from '../_models/zona';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ZonaHistorico } from '../_models/zona-historico';
import { Observable } from 'rxjs';
import { Usuario } from '../_models/usuario';
import { BusquedaFiltros } from '../_models/busqueda-filtros';
import { ZonasLiberaciones } from '../_models/zonas-liberaciones';

@Injectable({
  providedIn: 'root'
})
export class ZonaLiberacionService {

  private serviceURL = AppSettings.rutServiciosAPL + '/api/zonasLiberaciones';

  constructor( private authHttp: HttpClient, private authenticationService: AutenticacionService ) {
  }

  get( id: string ) {
    return this.authHttp.get( this.serviceURL + id )
      .pipe( map( res => res as ZonasLiberaciones ) );
  }

  getAll() {
    return this.authHttp.get( this.serviceURL ).pipe( map( res => res as ZonasLiberaciones[] ) );
  }

  update( zonaLiberacion: ZonasLiberaciones ) {
    zonaLiberacion.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
    return this.authHttp.put( this.serviceURL, zonaLiberacion ).pipe( map( res => res as any ) );
  }

  liberarZona(zonaLiberar:ZonasLiberaciones) {
    zonaLiberar.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
    zonaLiberar.indicadorHabilitado = true;

    return this.authHttp.post( this.serviceURL, zonaLiberar )
      .pipe( map( res => res as ZonasLiberaciones ) );
  }



  }
